import { Region } from '../types/orderTypes';
import { HubSortListOrderEntry } from '../hooks/useFetchHubSortList';
import Fetch from '../utils/fetch';
import { settings } from '../settings';

export interface LineHaulSortListEntry {
  targetRegion: Region;
  orders: HubSortListOrderEntry[];
}

export default async function fetchLineHaulSortList(
  startRegion: Region
): Promise<LineHaulSortListEntry[]> {
  const response = await Fetch.get({
    url: `${settings.newApiUrl}/hubsort/linehaul/${startRegion}`,
  });
  if (response.ok) {
    const sortList = (await response.json()) as LineHaulSortListEntry[];
    return sortList;
  }
  throw new Error(
    `Could not fetch line haul sort list, status was ${response.status}`
  );
}
